export enum PermissionType {
	LEGACY_LEXILE = 1,
	NEWS = 2,
	SHARED_LOGIN = 3,
	LEGACY_STAR = 177,
	METAMETRICS_LEXILE = 235,
	LEXILE_DISPLAY = 236,
	PAS = 237,
	READALOUD = 254
}
